import { atom } from "recoil";
import { Country } from "../model";

export const countriesState = atom<Country[] | undefined>({
  key: 'countriesState',
  default: undefined,
});